<template>
  <ion-page>
    <ion-content>
      <div class="container-login">
        <!--<router-link to="/userlogin" replace>
          <ion-icon class="back-icon" src="assets/icon/arrow-left.svg" />
        </router-link>-->
        <div class="welcome">
          <img src="assets/images/welcome.png" />
        </div>
        <div align="center">
          <span class="welcome-h1">One Coffee</span>

          <h1 class="h1-userlogin">Password successfully changed.</h1>
          <span class="span-login"
            >You can now login using your new password. Please use the OneCoffee
            App to login.
          </span>
          <!--<router-link to="/userlogin" replace
          ><ion-button expand="block" color="primary" class="btn-userlogin"
            >Back to Login</ion-button
          ></router-link
        >-->
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>
<script>
import { defineComponent } from "vue";
import { IonContent, IonPage, IonIcon, IonButton } from "@ionic/vue";

export default defineComponent({
  components: { IonContent, IonPage, IonIcon, IonButton },
});
</script>
<style scoped>
.welcome img {
  margin-top: 0%;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  width: 10%;
  display: block;
}
.welcome-h1 {
  font-family: "Gilroy-Medium";
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
  margin-top: 0%;
  margin-bottom: 2%;
}
.container-login {
  padding: 10%;
}
.span-login {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  color: #666666;
  display: block;
  margin-bottom: 10%;
}
.h1-userlogin {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  color: #1b1b1b;
}
</style>
